interface ToggleSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  // Shown beside the switch — say what the current state means, e.g.
  // "Required" / "Optional", rather than a bare on/off.
  label?: string;
  disabled?: boolean;
  // For screen readers when the visible label alone isn't enough.
  ariaLabel?: string;
}

/** An on/off switch. Styled by .toggle-switch in styles.css. */
const ToggleSwitch = ({ checked, onChange, label, disabled, ariaLabel }: ToggleSwitchProps) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    aria-label={ariaLabel}
    className="toggle-switch"
    disabled={disabled}
    onClick={() => onChange(!checked)}
  >
    <span className="toggle-switch-track">
      <span className="toggle-switch-thumb" />
    </span>
    {label && <span>{label}</span>}
  </button>
);

export default ToggleSwitch;
